'use client';

import { BREAKPOINTS, CONTAINER, MAXIMUM_COL } from './constants.js';

var createRowCssString = function (gutter) {
    if (gutter[0] === 0 && gutter[1] === 0)
        return '';
    var rowGap = gutter[0];
    var colGap = gutter[1];
    return "\n        margin-left: calc(-0.5 * ".concat(colGap, "px);\n        margin-right: calc(-0.5 * ").concat(colGap, "px);\n        margin-top: calc(-1 * ").concat(rowGap, "px);\n      ");
};
var getGapFromGutter = function (gutter) {
    if (!gutter)
        return [0, 0];
    if (typeof gutter === 'number') {
        return [gutter, gutter];
    }
    return gutter;
};
var renderCssStringOfRow = function (gutter) {
    var gap = null;
    var responsive = null;
    if (typeof gutter === 'object' && !Array.isArray(gutter)) {
        responsive = gutter;
    }
    else {
        gap = getGapFromGutter(gutter);
    }
    if (gap) {
        return createRowCssString(gap);
    }
    if (responsive) {
        var cssString_1 = '';
        Object.keys(responsive).map(function (breakpoint) {
            if (breakpoint === 'xs') {
                cssString_1 += createRowCssString(getGapFromGutter(responsive === null || responsive === void 0 ? void 0 : responsive[breakpoint]));
            }
            cssString_1 += "\n                @media screen and (min-width: ".concat(BREAKPOINTS[breakpoint], "px) {\n                  ").concat(createRowCssString(getGapFromGutter(responsive === null || responsive === void 0 ? void 0 : responsive[breakpoint])), "\n                }\n            ");
        });
        return cssString_1;
    }
    return '';
};
var renderGap = function (colGap, rowGap) {
    return "\n        ".concat(colGap > 0 ? "padding-left: calc(0.5 * ".concat(colGap, "px);") : '', "\n        ").concat(colGap > 0 ? "padding-right: calc(0.5 * ".concat(colGap, "px);") : '', "\n        ").concat(rowGap > 0 ? "padding-top: ".concat(rowGap, "px;") : '', "\n");
};
var renderAutoLayoutString = function (type) {
    if (type === 'auto') {
        return 'flex: 0 0 auto;max-width:none;';
    }
    return "flex: 1 1 0;max-width:100%;";
};
var createColCssString = function (gutter, col) {
    var colSpan = 0;
    var colOffset = 0;
    var colOrder = 0;
    var rowGap = gutter[0];
    var colGap = gutter[1];
    if (col) {
        if (typeof col === 'number') {
            colSpan = col;
        }
        else if (col instanceof Object) {
            colSpan = col.span;
            colOffset = col.offset || 0;
            colOrder = col.order || 0;
        }
        else {
            /*
             * Return css string immediately if column has auto layout
             * */
            return "\n                ".concat(renderAutoLayoutString(col), "\n                ").concat(renderGap(colGap, rowGap), "\n                ").concat(colOrder ? "order: ".concat(colOrder, ";") : '', "\n            ");
        }
    }
    var containerWidth = (colSpan / MAXIMUM_COL) * 100;
    var containerOffset = colOffset > 0 ? (colOffset / MAXIMUM_COL) * 100 : null;
    return "\n        ".concat(containerWidth > 0 ? "flex: 0 0 ".concat(containerWidth, "%;") : '', "\n        ").concat(containerWidth > 0 ? "max-width: ".concat(containerWidth, "%;") : '', "\n        ").concat(renderGap(colGap, rowGap), "\n        ").concat(containerOffset !== null ? "margin-left: ".concat(containerOffset, "%;") : '', "\n        ").concat(colOrder ? "order: ".concat(colOrder, ";") : '', "\n    ");
};
var renderCssStringOfCol = function (breakpoints, gutter) {
    var gap = null;
    var responsive = null;
    var cssString = '';
    if (typeof gutter === 'object' && !Array.isArray(gutter)) {
        responsive = gutter;
    }
    else {
        gap = getGapFromGutter(gutter);
    }
    Object.keys(breakpoints).map(function (breakpoint) {
        if (breakpoint === 'xs') {
            if (gap) {
                cssString += createColCssString(gap, breakpoints[breakpoint]);
                return;
            }
            if (responsive) {
                cssString += createColCssString(getGapFromGutter(responsive[breakpoint]), breakpoints[breakpoint]);
                return;
            }
        }
        if (responsive) {
            if (!breakpoints[breakpoint] && !responsive[breakpoint])
                return;
            cssString += "\n                @media screen and (min-width: ".concat(BREAKPOINTS[breakpoint], "px) {\n                    ").concat(createColCssString(getGapFromGutter(responsive[breakpoint]), breakpoints[breakpoint]), "\n                }\n            ");
            return;
        }
        if (breakpoints[breakpoint]) {
            cssString += "\n                @media screen and (min-width: ".concat(BREAKPOINTS[breakpoint], "px) {\n                    ").concat(createColCssString([0, 0], breakpoints[breakpoint]), "\n                }\n            ");
        }
    });
    return cssString;
};
var renderCssStringOfContainer = function (container) {
    var cssString = '';
    var containerKey;
    var padding = 0;
    if (container) {
        containerKey = Object.keys(container)[0];
        if (containerKey) {
            if (containerKey !== 'responsive') {
                padding = container[containerKey] || 0;
                cssString = "\n                  width: 100%;\n                  max-width: ".concat(containerKey === 'full'
                    ? CONTAINER[containerKey]
                    : "".concat(Number(CONTAINER[containerKey]) + padding * 2, "px"), ";\n                  padding: 0 ").concat(padding, "px;\n                  margin: 0 auto;\n                ");
            }
            else {
                /*
                 * When container has responsive, the responsive is always has at least 1 item (xs is required).
                 * So that, i can make type convention containerResponsive as TContainerResponsive
                 * */
                var containerResponsive_1 = container[containerKey];
                Object.keys(containerResponsive_1).forEach(function (key) {
                    var containerResponsiveItem = containerResponsive_1[key];
                    if (containerResponsiveItem) {
                        var size = containerResponsiveItem.size;
                        padding = containerResponsiveItem.offset || 0;
                        if (key === 'xs') {
                            cssString += "\n                                width: 100%;\n                                max-width: ".concat(size === 'full' ? CONTAINER[size] : "".concat(Number(CONTAINER[size]) + padding * 2, "px"), ";\n                                padding: 0 ").concat(padding, "px;\n                                margin: 0 auto;\n                            ");
                            return;
                        }
                        cssString += "\n                            width: 100%;\n                            @media screen and (min-width: ".concat(BREAKPOINTS[key], "px) {\n                                max-width: ").concat(size === 'full' ? CONTAINER[size] : "".concat(Number(CONTAINER[size]) + padding * 2, "px"), ";\n                                ").concat(padding ? "padding: 0 ".concat(padding, "px;") : '', "\n                            }\n                        ");
                    }
                });
            }
        }
    }
    return cssString;
};

export { renderCssStringOfCol, renderCssStringOfContainer, renderCssStringOfRow };
//# sourceMappingURL=helper.js.map
